import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useSystemFetch, useSystemInfo } from '#layers/base/public';

export interface AcceptTermsPayload {
	fullName: string;
	acceptTerms: boolean;
	acceptMarketing: boolean;
}

export const useOnboardingStore = defineStore('onboarding', () => {
	const systemInfo = useSystemInfo();
	const fetch = useSystemFetch();
	const acceptTermsLoading = ref(false);
	const acceptTermsError = ref<unknown | null>(null);

	function overrideOnboardingResult(value: { requireAcceptTerms?: boolean }) {
		const onboarding = systemInfo.onboarding;
		if (onboarding) Object.assign(onboarding, value);
	}

	async function acceptTerms(payload: AcceptTermsPayload): Promise<boolean> {
		acceptTermsError.value = null;
		acceptTermsLoading.value = true;

		try {
			await fetch('system/bootstrap', { method: 'POST', body: payload });
			await systemInfo.refresh();
			return true;
		}
		catch (error) {
			acceptTermsError.value = error;
			return false;
		}
		finally {
			acceptTermsLoading.value = false;
		}
	}

	return {
		acceptTermsLoading: computed(() => acceptTermsLoading.value),
		acceptTermsError: computed(() => acceptTermsError.value),
		overrideOnboardingResult,
		acceptTerms,
		clearAcceptTermsError: () => {
			acceptTermsError.value = null;
		},
		requireCreateUser: computed(() => systemInfo.onboarding?.requireCreateUser === true),
		requireAcceptTerms: computed(() => systemInfo.onboarding?.requireAcceptTerms === true),
	};
});
